import React from 'react';
import { T } from '@colonist/ui';
import styles from './PatchNotesAnnouncementSection.module.scss';
export function PatchNotesAnnouncementSection({ announcements }) {
    if (announcements.length == 0) return null;
    return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
        className: styles.header
    }, /*#__PURE__*/ React.createElement("h3", {
        className: styles.title
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:popups.patchNote.announcement'
        }
    }))), /*#__PURE__*/ React.createElement("div", {
        className: styles.body
    }, announcements.map((announcement, index)=>/*#__PURE__*/ React.createElement("p", {
            className: styles.announcement,
            key: index,
            dangerouslySetInnerHTML: {
                __html: announcement
            }
        }))));
}
